import React from "react";

// Top-down quadcopter drone icon (custom SVG). Sizes via `size` prop, colors via `currentColor`.
export default function DroneIcon({ size = 24, className = "", strokeWidth = 1.75, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {/* central body */}
      <rect x="9" y="9" width="6" height="6" rx="1" />
      {/* diagonal arms */}
      <line x1="6" y1="6" x2="9" y2="9" />
      <line x1="18" y1="6" x2="15" y2="9" />
      <line x1="6" y1="18" x2="9" y2="15" />
      <line x1="18" y1="18" x2="15" y2="15" />
      {/* four rotor rings */}
      <circle cx="5" cy="5" r="2.2" />
      <circle cx="19" cy="5" r="2.2" />
      <circle cx="5" cy="19" r="2.2" />
      <circle cx="19" cy="19" r="2.2" />
      {/* camera dot */}
      <circle cx="12" cy="12" r="0.9" fill="currentColor" stroke="none" />
    </svg>
  );
}
